import { FaCheck, FaMinus } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 CHECKBOX

    El input real está oculto pero presente: así siguen funcionando el
    teclado, el foco y el envío del formulario. La caja que se ve es un
    <span> que sí podemos pintar con los tokens.

    isIndeterminate sirve para "seleccionar todos" en una tabla.
*/

export const FieldCheckbox = ({
    id, name, label, hint, error, text,
    isChecked = false, isIndeterminate = false, onChange,
    isRequired = false, isDisabled = false,
    span = 1, ...rest
}) => {

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error} layout="inline"
        isRequired={isRequired} isDisabled={isDisabled} span={span} >

        <label className={`${BLOCK}__check`} htmlFor={DOM_ID}>

            <input id={DOM_ID} data-field={name ?? id} name={name ?? id} type="checkbox"
                className={`${BLOCK}__check_input`}
                checked={isChecked} onChange={onChange}
                required={isRequired} disabled={isDisabled}
                aria-invalid={!!error}
                {...rest} />

            <span className={`${BLOCK}__check_box`} aria-hidden="true">
                {isIndeterminate ? <FaMinus /> : <FaCheck />}
            </span>

            {text && <span className={`${BLOCK}__check_text`}>{text}</span>}

        </label>

    </FieldShell>
);
};
